import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getShift } from 'lib/selectors/getShift';

const getShiftStart = createSelector([getShift], (shift) => {
  return _get(shift, 'startAt');
});

export { getShiftStart };
